import { Component, Input, OnInit, Output ,EventEmitter} from '@angular/core';
import { TypePoiRequestDto, TypePoiResponseDto } from '../type-poi.model';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { TypePoiRestService } from '../type-poi-rest.service';
import { TypePoiStateService } from '../type-poi-state.service';
import { ToastrService } from 'ngx-toastr';
import { MarkersService } from '../markers.service';
import { rapportsDir } from 'src/app/global.config';
import { DataManagementService } from '../../../data-management.service';
import { PointInterest } from '../../../data-management.model';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-type-poi-form',
  templateUrl: './type-poi-form.component.html',
  styleUrls: ['./type-poi-form.component.css']
})
export class TypePoiFormComponent implements OnInit {

  templateDownoaldLocation: string = rapportsDir;
  @Input()
  typePoiModal: ModalDirective;

  @Output()
  typePoiWasAdded: EventEmitter<TypePoiResponseDto> = new EventEmitter<TypePoiResponseDto>();

  @Output()
  typePoiWasUpdated: EventEmitter<TypePoiResponseDto> = new EventEmitter<TypePoiResponseDto>();

  typePoiRequest:TypePoiRequestDto;

  @Input()
  mode!:string;


  colors: any[] = [
        {
            id: 0,
            name: 'bleu',
            title: 'Bleu',
            color: '#3e64ff'
        },
        {
            id: 1,
            name: 'green',
            title: 'Vert',
            color: '#00FF00'
        },
        {
            id: 2,
            name: 'red',
            title: 'Rouge',
            color: '#FF0000'
        },
        {
            id: 3,
            name: 'yellow',
            title: 'Jeune',
            color: '#FFFF00'
        },
        {
            id: 4,
            name: 'orange',
            title: 'Orange',
            color: '#FFA500'
        }

    ];

  icons: any[] = [];
  loading:boolean = false;
  selectedIconName:string = '';

  pointInterestsPoint: PointInterest[] = [];
  poiDropdownSettings = {};
  poiItems: { text: string | number; id: number }[] = [];
  poiSelected: { text: string | number; id: number }[] = [];
  template: string = 'Pois_Type_Poi.xlsx';
  importedPois: { code: any; name: any }[];
  headers = ['Code', 'Nom'];
  selectedFile: File = null;

  constructor(private typePoiRestService:TypePoiRestService,
              private typePoiStateService:TypePoiStateService,
              public toastr: ToastrService,
              private markersService:MarkersService,
              private dataManagementService: DataManagementService){}


  ngOnInit() {
    this.typePoiStateService.getTypePoi().subscribe({
        next:(typePoiRequest)=>{
            this.typePoiRequest = typePoiRequest;
            if(this.typePoiRequest && this.typePoiRequest.pointInterestsIds && this.typePoiRequest.pointInterestsIds.length > 0){
              this.poiSelected = this.typePoiRequest.pointInterestsIds.map(p => {
                return {text:'',id:p}
              });
            }
            this.getIcons();
        }
    })

    this.loadPOI();

    this.poiDropdownSettings = {
      itemsShowLimit: 1,
      idField: 'id',
      textField: 'text',
    };
  }

  loadPOI() {
    if(this.dataManagementService && this.dataManagementService.getPoiInterests()){
          this.dataManagementService
            .getPoiInterests()
            .subscribe({
              next:(pointInterests)=>{
              pointInterests.forEach(pointInterest=>{
                if (pointInterest.type == "MARKER") {
                  this.pointInterestsPoint.push(pointInterest);
                  this.poiItems = this.pointInterestsPoint.map(p =>{
                      return {text:p.name , id:p.idPointInterest}
                  })
                }
              })
              }
        });
    }
  }

  onAdd(form: NgForm) {
          if(this.poiSelected && this.poiSelected.length > 0){
            const ids = this.poiSelected.map(p => p.id)
            this.typePoiRequest.pointInterestsIds = ids;
          }
          this.loading = true;
          this.typePoiRestService.addTypePoi(this.typePoiRequest).subscribe(typePoi => {
              this.toastr.success('Type Poi bien sauvegarder !', 'info');
              this.typePoiWasAdded.emit(typePoi);
              this.typePoiStateService.addTypePoi(typePoi);
              this.loading = false;
              this.typePoiRequest = new TypePoiRequestDto('','','',[])
          }, error => {
              let textError = JSON.parse(JSON.stringify(error.error || null)).errorMessage;
              if (JSON.parse(JSON.stringify(error.error || null)).errors) textError += ' ' + JSON.parse(JSON.stringify(error.error || null)).errors;
              this.toastr.error(textError, JSON.parse(JSON.stringify(error.error || null)).errorCode);
              this.loading = false;
          });
  }

  onUpdate(form: NgForm) {
          if(this.poiSelected && this.poiSelected.length > 0){
            const ids = this.poiSelected.map(p => p.id)
            this.typePoiRequest.pointInterestsIds = ids;
          }
          else{
            this.typePoiRequest.pointInterestsIds = []
          }
          this.loading = true;
          this.typePoiRestService.updateTypePoi(this.typePoiRequest).subscribe(typePoi => {
              this.toastr.success('Type Poi bien sauvegarder !', 'info');
              this.typePoiWasAdded.emit(typePoi);
              this.typePoiStateService.updateTypePoi(typePoi);
              this.loading = false;
              this.typePoiRequest = new TypePoiRequestDto('','','',[])
          }, error => {
              let textError = JSON.parse(JSON.stringify(error.error || null)).errorMessage;
              if (JSON.parse(JSON.stringify(error.error || null)).errors) textError += ' ' + JSON.parse(JSON.stringify(error.error || null)).errors;
              this.toastr.error(textError, JSON.parse(JSON.stringify(error.error || null)).errorCode);
              this.loading = false;
          });
  }

  getIcons() {
        const c = this.typePoiRequest?.color;
        if(c){
            const colorName = this.colors.filter(color => color.color == c)[0].name;
            const markers = this.markersService.getMarkers();
            this.icons = markers.filter(marker => marker.url.includes(colorName))
            if(this.mode === 'ADD'){
                this.typePoiRequest.imageUri = this.icons[0].url;
                this.selectedIconName = this.icons[0].name
            }
        }
        else {
            if(!this.typePoiRequest.imageUri || this.typePoiRequest.imageUri.length === 0){
              const markers = this.markersService.getMarkers();
              this.typePoiRequest.imageUri = markers[0].url;
              this.selectedIconName = markers[0].name;
            }
        }

    }

    chooseIcon(icon:{id:number,name:string,url:string}){
        this.selectedIconName = icon.name;
        this.typePoiRequest.imageUri = icon.url;
    }

    onFileChanged(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.readExcelFile(this.selectedFile);
    }
  }

    readExcelFile(blob: Blob): void {
        const reader: FileReader = new FileReader();
        reader.onload = (e: any) => {
          const binaryData: string = e.target.result;
          const workbook: XLSX.WorkBook = XLSX.read(binaryData, { type: 'binary' });
          const sheetName: string = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const data: any[] = XLSX.utils.sheet_to_json(sheet, { range: 3 });
          if (data.length !== 0) {
            const keys1 = Object.keys(data[0]).sort();
            if (JSON.stringify(keys1) === JSON.stringify(this.headers.sort())) {
              this.importedPois = data.map(item => ({
                code: item['Code'],
                name: item['Nom'],
              }));
              if(this.importedPois && this.importedPois.length > 0){
                this.onUpload()
              }
            } else {
              this.toastr.error('Incompatible template');
            }
          } else {
            this.toastr.error('fichier excel est vide.');
          }
        };
        reader.readAsBinaryString(blob);
      }


      onUpload() {
        const notExist: any[] = [];
        this.importedPois.map(poi => {
          let poiToAdd = this.pointInterestsPoint.filter(item => item.name === poi?.code);
          if (!poiToAdd || poiToAdd.length === 0) {
            poiToAdd = this.pointInterestsPoint.filter(item => item.name === poi?.name);
          }

          if (poiToAdd && poiToAdd.length > 0) {
            if (!this.poiSelected) {
                  this.poiSelected = [];
                }
            this.poiSelected = [
              ...this.poiSelected,
              {
                id: poiToAdd[0].idPointInterest,
                text: poiToAdd[0].name,
              }
             ];
          } else {
            if (!notExist.find(item => item.name === poi.name || item.code === poi.code)) {
              notExist.push(poi);
            }
          }
        });
        notExist?.map(poi => {
          this.toastr.warning(`POI ${poi.name} (${poi.code}) n'existe pas.`);
        });
        this.selectedFile = null;
  }
}
